export default __webpack_public_path__ + "static/yuffie-85856f4e60aca225fe16b94d82f549fe.png";